import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import { navigatedToPreviousStep } from "../../../../redux/slice/apartmentRental/apartmentRentalSlice";

interface StyledIconButtonProps {
  show: boolean;
}

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "show",
})<StyledIconButtonProps>(({ show, theme }) => ({
  position: "absolute",
  ":hover": {
    backgroundColor: "transparent"
  },
  top: 0,
  left: 0,
  color: theme.palette.primary.main,
  display: show ? "flex" : "none",
}));

const BackText = styled(Typography)({
  color: "black",
});

interface BookLocationNavigateBackActionProps {
  /**
   * What "back" means on the FIRST step, if anything. Object-first (#3035):
   * from the time step back to the room list, which sits in front of the step
   * machine rather than inside it. Absent, the first step has no back button,
   * as before.
   */
  onBackAtStart?: () => void;
}

const ApartmentRentalNavigateBackAction = ({
  onBackAtStart,
}: BookLocationNavigateBackActionProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { step } = useSelector((state: RootState) => state.apartment);

  const showBackButton = step !== 0 || !!onBackAtStart;

  const handleBackClick = () => {
    if (step === 0 && onBackAtStart) {
      onBackAtStart();
      return;
    }
    dispatch(navigatedToPreviousStep());
  };

  return (
    <StyledIconButton show={showBackButton} onClick={handleBackClick}>
      <ChevronLeftIcon className="size-8 text-black-500" />
      <BackText>{t("general.back")}</BackText>
    </StyledIconButton>
  );
};

export default ApartmentRentalNavigateBackAction;
